const SIGNUP_FLOW_PARAM_NAMES = [
  'BASIC_MEMBERSHIP_PLAN',
  'PREMIUM_MEMBERSHIP_PLAN',
  'DOCUSEAL_RULES_AND_REGULATION_SRC',
  'DOCUSEAL_MEMBERSHIP_APP_SRC',
  'DOCUSEAL_MEMBERSHIP_AGREEMENT_SRC',
  'STRIPE_ACCESS_KEY',
];

const SIGNUP_SERVICE_NAME = 'signup_flow';

export { SIGNUP_FLOW_PARAM_NAMES, SIGNUP_SERVICE_NAME };